/* SCORING CONFIG (FIN-10480) */
export const FETCH_SCORING_CONFIG = 'FETCH_SCORING_CONFIG';
export const FETCH_SCORING_CONFIG_SUCCESS = 'FETCH_SCORING_CONFIG_SUCCESS';
export const FETCH_SCORING_CONFIG_FAIL = 'FETCH_SCORING_CONFIG_FAIL';

export const SAVE_SCORING_CONFIG = 'SAVE_SCORING_CONFIG';
export const SAVE_SCORING_CONFIG_SUCCESS = 'SAVE_SCORING_CONFIG_SUCCESS';
export const SAVE_SCORING_CONFIG_FAIL = 'SAVE_SCORING_CONFIG_FAIL';

export const RESET_SCORING_CONFIG = 'RESET_SCORING_CONFIG';
export const RESET_SCORING_CONFIG_SUCCESS = 'RESET_SCORING_CONFIG_SUCCESS';
export const RESET_SCORING_CONFIG_FAIL = 'RESET_SCORING_CONFIG_FAIL';

export const SCORING_CONFIG_CLEAR = 'SCORING_CONFIG_CLEAR';

export const fetchScoringConfig = (payload) => ({
  type: FETCH_SCORING_CONFIG,
  payload
});
export const fetchScoringConfigSuccess = (payload) => ({
  type: FETCH_SCORING_CONFIG_SUCCESS,
  payload
});
export const fetchScoringConfigFail = (payload) => ({
  type: FETCH_SCORING_CONFIG_FAIL,
  payload
});

export const saveScoringConfig = (payload) => ({
  type: SAVE_SCORING_CONFIG,
  payload
});
export const saveScoringConfigSuccess = (payload) => ({
  type: SAVE_SCORING_CONFIG_SUCCESS,
  payload
});
export const saveScoringConfigFail = (payload) => ({
  type: SAVE_SCORING_CONFIG_FAIL,
  payload
});

export const resetScoringConfig = (payload) => ({
  type: RESET_SCORING_CONFIG,
  payload
});
export const resetScoringConfigSuccess = (payload) => ({
  type: RESET_SCORING_CONFIG_SUCCESS,
  payload
});
export const resetScoringConfigFail = (payload) => ({
  type: RESET_SCORING_CONFIG_FAIL,
  payload
});

export const scoringConfigClear = () => ({ type: SCORING_CONFIG_CLEAR });
